export default __webpack_public_path__ + "static/media/cancel.6136df25.png";